import React, { useMemo, useState } from "react";
import Layout from "./Layout";
import vipData from "./vip-levels.json";

const PAGE_SIZE = 10;
const MAX_VISIBLE = 6; // matches original "1 2 3 … 10 11"

const cell =
  "vip-summary-table-content-mobile white--text v-card v-sheet theme--light elevation-0";

// Vuetify v2 pagination algorithm
const getPageItems = (page, length, maxLength = MAX_VISIBLE) => {
  const range = (from, to) =>
    Array.from({ length: to - from + 1 }, (_, i) => from + i);

  if (length <= maxLength) return range(1, length);

  const even = maxLength % 2 === 0 ? 1 : 0;
  const left = Math.floor(maxLength / 2);
  const right = length - left + 1 + even;

  if (page > left && page < right) {
    return [1, "...", ...range(page - left + 2, page + left - 2 - even), "...", length];
  }
  if (page === left) {
    return [...range(1, page + left - 1 - even), "...", length];
  }
  if (page === right) {
    return [1, "...", ...range(page - left + 1, length)];
  }
  return [...range(1, left), "...", ...range(right, length)];
};

const socials = [
  { img: "TELE.png", url: "https://t.me/winx9Officials" },
  { img: "FB.png", url: "https://facebook.com/winx9official" },
  { img: "IG.png", url: "https://www.instagram.com/winx9officials" },
  { img: "YT.png", url: "https://www.youtube.com/@winx9official" },
  { img: "X.png", url: "https://x.com/winx9Official" },
];

const Rank = ({
  vipLevels = vipData.levels,
  userName = "S",
  currentLevel = 65,
  currentTurnover = 1272358,
  canClaim = false,
  onClaim,
}) => {
  const totalPages = Math.ceil(vipLevels.length / PAGE_SIZE);
  const [page, setPage] = useState(
    Math.min(Math.max(Math.ceil(currentLevel / PAGE_SIZE), 1), totalPages)
  );

  const pageLevels = useMemo(
    () => vipLevels.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE),
    [vipLevels, page]
  );

  const pageItems = useMemo(() => getPageItems(page, totalPages), [page, totalPages]);

  const target =
    vipLevels.find((v) => v.level === currentLevel)?.requirement || 0;
  const progress = target ? Math.min((currentTurnover / target) * 100, 100) : 0;

  const isLast = (i) => i === pageLevels.length - 1;
  const selected = (v) => (v.level === currentLevel ? "selected-level" : "");

  return (
    <Layout>
      <div className="vip-layout-background px-2">
        <div className="vip-card justify-center v-card v-sheet theme--light">
          {/* Progress card */}
          <div className="row no-gutters justify-center mx-2 mt-8 mb-8">
            <div className="col-md-6 col-lg-10 col-12">
              <div className="vip-progress-card mt-8 v-card v-sheet theme--light elevation-0">
                <div className="row px-8 pt-4 no-gutters align-end">
                  <div className="col">
                    <div className="row no-gutters justify-center">
                      <div className="text-center mb-1 ml-2 col col-12">
                        <label className="white--text font-weight-bold subtitle-1">
                          JAYA RANK
                          <br />
                          Welcome Back, {userName}
                        </label>
                      </div>
                    </div>
                    <div className="row no-gutters justify-center">
                      <div className="text-left col-md-1 col-1">
                        <div
                          className="v-avatar vip-process-bar-icon rounded"
                          style={{ height: 50, minWidth: 50, width: 50 }}
                        >
                          <img src="/static/image/vip-level-no2.png" alt="" />
                          <span className="centered white--text">{currentLevel}</span>
                        </div>
                      </div>
                      <div className="col-md-10 col-lg-8 col-10">
                        <div
                          role="progressbar"
                          aria-valuemin={0}
                          aria-valuemax={100}
                          aria-valuenow={progress}
                          className="v-progress-linear vip-progress-bar v-progress-linear--visible theme--light"
                          style={{ height: 35 }}
                        >
                          <div
                            className="v-progress-linear__background primary"
                            style={{ opacity: 0.3, left: `${progress}%`, width: `${100 - progress}%` }}
                          />
                          <div className="v-progress-linear__buffer" />
                          <div
                            className="v-progress-linear__determinate primary"
                            style={{ width: `${progress}%` }}
                          />
                          <div className="v-progress-linear__content">
                            <label>
                              {currentTurnover} / {target}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row px-8 pt-4 pb-4 no-gutters justify-center">
                  <div className="text-center col col-6 pl-2">
                    <button
                      type="button"
                      disabled={!canClaim}
                      onClick={onClaim}
                      className={`pa-2 dialog-button mr-2 v-btn v-btn--has-bg theme--light v-size--default buttonPrimary theme-button subtitle-1 ${!canClaim ? "v-btn--disabled" : ""}`}
                    >
                      <span className="v-btn__content">Claim Rewards</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* VIP table */}
          <div className="mx-2 mt-8 mb-8 vip-summary-container">
            {/* Level row */}
            <div className="row d-flex flex-nowrap no-gutters align-center">
              <div className="col col-3">
                <div
                  className="vip-summary-table-mobile border-top-left-radius white--text pl-3 v-card v-sheet theme--light elevation-0"
                  style={{ height: 38 }}
                >
                  Level
                </div>
              </div>
              {pageLevels.map((v, i) => (
                <div key={v.level} className="text-center col col-3">
                  <div
                    className={`vip-summary-table-mobile white--text v-card v-sheet theme--light elevation-0 ${selected(v)} ${isLast(i) ? "border-top-right-radius" : ""}`}
                  >
                    <div className="v-avatar" style={{ height: 30, minWidth: 30, width: 30 }}>
                      {v.level === currentLevel ? (
                        <img src="/static/image/vip-level-icon.png" alt="" />
                      ) : (
                        <>
                          <img src="/static/image/vip-level-no.png" alt="" />
                          <span className="centered">{v.level}</span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Rewards row */}
            <div
              className="row flex-nowrap no-gutters align-center"
              style={{ borderBottom: "0.5px solid white" }}
            >
              <div className="col col-3">
                <div className={`${cell} pl-3`} style={{ height: 83 }}>
                  Rewards
                </div>
              </div>
              {pageLevels.map((v) => (
                <div key={v.level} className="col col-3">
                  <div className={`${cell} ${selected(v)} content`}>
                    <div className="row no-gutters">
                      <div className="text-center col col-12">
                        <div
                          className="icon-size mb-2 mx-auto"
                          style={{
                            backgroundImage: "url('/static/image/deposit-bonus-coin.png')",
                            backgroundPosition: "center",
                            backgroundSize: "cover",
                          }}
                        />
                      </div>
                      <div
                        className={`text-center col col-12 ${v.highlight ? "bold-prize-text" : ""}`}
                      >
                        FREE
                        <br />
                        {v.rewardType === "ITEM" ? v.rewardItem : `৳${v.reward}`}
                        {v.note && <label style={{ fontSize: 8 }}>{v.note}</label>}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Requirement row */}
            <div className="row flex-nowrap no-gutters align-center">
              <div className="col col-3">
                <div className={`${cell} border-bottom-left-radius pl-3`} style={{ height: 46 }}>
                  Requirement
                </div>
              </div>
              {pageLevels.map((v, i) => (
                <div key={v.level} className="col col-3">
                  <div
                    className={`${cell} text-center ${selected(v)} ${isLast(i) ? "border-bottom-right-radius" : ""}`}
                    style={{ height: 46 }}
                  >
                    <span>৳{v.requirement}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Pagination */}
          <div className="row no-gutters">
            <div className="text-center mb-6 col col-12">
              <nav role="navigation" aria-label="Pagination Navigation" className="vip_summary_pagination">
                <ul className="v-pagination v-pagination--circle theme--dark">
                  <li>
                    <button
                      type="button"
                      aria-label="Previous page"
                      disabled={page === 1}
                      onClick={() => setPage((p) => p - 1)}
                      className={`v-pagination__navigation ${page === 1 ? "v-pagination__navigation--disabled" : ""}`}
                    >
                      <i aria-hidden="true" className="v-icon notranslate material-icons theme--dark">
                        arrow_back_ios
                      </i>
                    </button>
                  </li>
                  {pageItems.map((item, idx) => (
                    <li key={`${item}-${idx}`}>
                      {item === "..." ? (
                        <span className="v-pagination__more">...</span>
                      ) : (
                        <button
                          type="button"
                          aria-label={item === page ? `Current Page, Page ${item}` : `Goto Page ${item}`}
                          aria-current={item === page ? "true" : undefined}
                          onClick={() => setPage(item)}
                          className={`v-pagination__item ${item === page ? "v-pagination__item--active primary" : ""}`}
                        >
                          {item}
                        </button>
                      )}
                    </li>
                  ))}
                  <li>
                    <button
                      type="button"
                      aria-label="Next page"
                      disabled={page === totalPages}
                      onClick={() => setPage((p) => p + 1)}
                      className={`v-pagination__navigation ${page === totalPages ? "v-pagination__navigation--disabled" : ""}`}
                    >
                      <i aria-hidden="true" className="v-icon notranslate material-icons theme--dark">
                        arrow_forward_ios
                      </i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <footer className="v-footer footer v-sheet theme--light footer_color">
        <div className="footer_wrapper">
          <div className="footer-container-1">
            <div className="payment-methods">
              <div className="footer-title mb-2">Payment Methods</div>
              <div className="d-flex flex-wrap payment-methods-icons">
                <img
                  className="footer-icon"
                  height={32}
                  src="https://winx9bangla.com/static/image/footer/payment-bank.svg"
                  alt="Bank"
                />
              </div>
            </div>
            <div className="d-flex flex-column customer-support">
              <label className="footer-title">Customer Support</label>
              <div className="d-flex">
                <img
                  src="https://winx9bangla.com/static/image/footer/icon-24hr.svg"
                  alt="24hr"
                  style={{ maxHeight: 32, maxWidth: 32 }}
                />
                <div className="d-flex flex-column column-gap justify-center align-center">
                  <div className="footer-support secondary--text">
                    <a
                      href="https://direct.lc.chat/14469159/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      Chat Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="community">
              <div className="row mb-2 no-gutters">
                <label className="footer-title">Certifications</label>
              </div>
              <div className="row no-gutters">
                <a href="https://casinosanalyzer.com/online-casinos">
                  <img height={32} src="/static/image/footer/gaming_Casino_Analyzer.svg" alt="" />
                </a>
                <img height={32} src="/static/image/footer/gaming_iTechLabs.svg" alt="" className="ml-2" />
              </div>
            </div>
            <div className="customer-support">
              <div className="footer-title mb-2">Community Website</div>
              <div className="d-flex flex-wrap payment-methods-icons">
                <img className="footer-icon" height={32} src="https://winx9bangla.com/static/image/footer/safe2.png" alt="" />
                <img className="footer-icon" height={32} src="https://winx9bangla.com/static/image/footer/safe1_2.png" alt="" />
                <img height={32} src="/static/image/footer/gaming_license.webp" alt="" />
              </div>
            </div>
            <div>
              <div className="footer-title mb-2">Follow Us</div>
              <div className="d-flex flex-wrap payment-methods-icons">
                {socials.map((s) => (
                  <a key={s.img} href={s.url} target="_blank" rel="noopener noreferrer">
                    <img height={32} src={`/static/image/footer/${s.img}`} alt="" />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="py-5 col col-12">
            <hr className="v-divider theme--light" />
          </div>
          <div className="seo_text text-left">
            Trusted Best Online Cricket Exchange, Betting Sites in Bangladesh and South Asiawinx9 is one
            of the most famous online betting sites on the Internet for online cricket betting, live
            cricket betting, live casinos, soccer, slot games and table games. It focuses on a wide range
            of sports for online betting like others, but the best thing about winx9 is once the match
            starts, you can place in-play bets during the match.winx9 offers multiple currencies for all
            countries. Now players from Bangladesh can enjoy betting with local payment BDT. When you
            enter winx9 online betting site, you’ll get to know all about winx9 and how it's simple to
            place a wager on winx9, just simply click on that sport match that is in your favour. winx9
            makes it easy for players to deposit using various payment methods with fast and secure
            transactions.
          </div>
          <div className="py-2 col col-12">
            <hr className="v-divider theme--light" />
          </div>
          <div className="row align-center cols no-gutters justify-space-between">
            <div className="row mb-2 no-gutters">
              <img
                src="../../assets/images/logo.png"
                alt="winx9 cricket exchange"
                className="footer-logo"
                style={{ alignSelf: "end" }}
              />
            </div>
            <div className="faq-container no-gutters col-md-4 col-12">
              <div className="row faq-wrapper">
                <a href="/info/faq" className="footer-title">Responsible Gaming</a>
                <a href="/info/tnc" className="footer-title">Terms And Condition</a>
                <a href="/info/about-us" className="footer-title">About us</a>
              </div>
              <div className="copyright" style={{ color: "var(--v-description-darken3)" }}>
                Copyright © {new Date().getFullYear()} winx9.All rights are reserved.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </Layout>
  );
};

export default Rank;
